module.exports = "/fonts/vendor/element-ui/lib/theme-chalk/element-icons.ttf?6f0a76321d30f3c8120915e57f7bd77e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = YiW1
// module chunks = 23